<template
  ><v-dialog v-model="visible" max-width="500">
    <v-card class="px-1 py-3">
      <v-card-title class="text-h5">{{ title }}</v-card-title>
      <v-card-text class="text-body-1 my-1">{{ description }}</v-card-text>
      <v-card-actions>

        <v-btn color="error" @click="confirm">{{ $t("confirm") }}</v-btn>
        <v-btn text color="grey" @click="cancel">{{ $t("cancel") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </template>

<script>
export default {
  name: "ConfirmActionDialogue",
  props: {
    title: {
      type: String,
      default: "Are you sure?"
    },
    description: {
      type: String,
      default: "This action cannot be undone."
    }
  },
  data() {
    return {
      visible: false
    };
  },
  emits: ["confirm", "cancel"],
  methods: {
    showDialog() {
      this.visible = true;
    },
    confirm() {
      this.$emit("confirm");
      this.visible = false;
    },
    cancel() {
      this.$emit("cancel");
      this.visible = false;
    }
  }
};
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
